(function($) {

    $(window).on("load", function() {
        $('#template').addClass('loaded');
    });
    
})( jQuery );
